import {
  actions,
  getCollectionComponentTypeByNameAsync,
  addAllowedTypeAsync,
  getCollectionComponentTypeByIdAsync,
  getCollectionComponentTypesLookupsAsync,
  createCollectionComponentTypeAsync,
  getCollectionComponentTypesDatatableAsync,
  setAllowedComponentTypesAsync,
  getCollectionComponentTypeByIdMultilingualAsync,
  createCollectionComponentTypeMultilingualAsync,
  editCollectionComponentTypeMultilingualAsync,
} from './slices';

export const CollectionComponetTypesActions = {
  ...actions,
  getCollectionComponentTypeByNameAsync,
  addAllowedTypeAsync,
  getCollectionComponentTypeByIdAsync,
  getCollectionComponentTypesLookupsAsync,
  createCollectionComponentTypeAsync,
  getCollectionComponentTypesDatatableAsync,
  setAllowedComponentTypesAsync,
  getCollectionComponentTypeByIdMultilingualAsync,
  createCollectionComponentTypeMultilingualAsync,
  editCollectionComponentTypeMultilingualAsync,
};

export * from './thunkHandlers';
